import { ReactElement, useState } from "react";
import { Upload } from "antd";
import { useNavigate } from "react-router-dom";
import { useFileUpload } from "../../lib/useFileUpload";
import UploadProgressBar from "../../shared-ui-components/UploadProgressBar";
import PopUp from "../../shared-ui-components/PopUp";
import TermsPopUp from "../../shared-ui-components/TermsPopUp";
import SubscribeForm from "../../shared-ui-components/SubscribeForm";
import SignInModal from "../../components/SignInModal";
import ToolTip from "../../shared-ui-components/ToolTip";
import { ReactComponent as UploadIcon } from "../../assets/icons/upload-icon-round.svg";
import { toHumanReadableSize } from "../../util/general";

const MAX_UPLOAD_SIZE = parseInt(
  process.env.REACT_APP_MAX_UPLOAD_SIZE || "104857600",
  10,
);

function showTerms() {
  const element = document.getElementById("cond");
  if (element) {
    window.scrollTo(0, 0);
    element.style.display = "block";
  }
}

export default function UploadSection(): ReactElement {
  const navigate = useNavigate();
  const [isSignInModalVisible, setIsSignInModalVisible] = useState(false);
  const [termsPopup, setTermsPopup] = useState(
    () => !localStorage.getItem("termsAccepted"),
  );

  const {
    uploadProps,
    uploadKey,
    showProgress,
    isAnalysing,
    progressPercentage,
    showSubscribeModal,
    setShowSubscribeModal,
  } = useFileUpload((analysisId) => navigate(`/analysis/${analysisId}`));

  return (
    <>
      <div className="upload-container">
        <Upload key={uploadKey} {...uploadProps}>
          <div className="file-upload-inner">
            <UploadIcon className="upload-icon-img" />
            <button className="front-upload-button">Choose File</button>
            <div className="tc" style={{ marginBottom: "20px" }}>
              By uploading a file you agree to the{" "}
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  showTerms();
                }}
              >
                Terms of Use
              </button>
              <br />
              <small>
                (Max file size&nbsp;
                <ToolTip
                  children={toHumanReadableSize(MAX_UPLOAD_SIZE)}
                  content="Please contact us about scanning larger files"
                />
                )
              </small>
            </div>
          </div>
        </Upload>
      </div>

      {(showProgress || isAnalysing) && (
        <div className="upload-loading-overlay">
          <div className="upload-loading-content">
            <h2>{isAnalysing ? "Analysing" : "Uploading"}</h2>
            {showProgress && (
              <UploadProgressBar
                percentage={progressPercentage}
                showPercentage={true}
                height={14}
              />
            )}
            {isAnalysing && !showProgress && (
              <div className="donut">
                <svg version="1.1" width="120px" height="120px">
                  <g transform="translate(60, 60)">
                    <circle r="50" className="circle-back" />
                    <circle r="50" className="circle-front" />
                  </g>
                </svg>
              </div>
            )}
          </div>
        </div>
      )}

      <TermsPopUp
        openModal={termsPopup}
        setOpenModal={setTermsPopup}
        fullWidth={0}
      >
        <div className="tc" style={{ marginBottom: "20px" }}>
          Please confirm that you have read and accept the{" "}
          <button onClick={showTerms}>Terms of Use</button> before proceeding.
        </div>
      </TermsPopUp>

      <PopUp
        openModal={showSubscribeModal}
        setOpenModal={setShowSubscribeModal}
        fullWidth={0}
      >
        <SubscribeForm
          setOpenModal={setShowSubscribeModal}
          onSignUp={() => setIsSignInModalVisible(true)}
        />
      </PopUp>

      <SignInModal
        isVisible={isSignInModalVisible}
        onClose={() => setIsSignInModalVisible(false)}
        onSignInSuccess={() => setIsSignInModalVisible(false)}
      />
    </>
  );
}
